// ** React Imports
import { useEffect, useState, useContext } from 'react'
import { Link } from 'react-router-dom'

// ** Utils
import { isUserLoggedIn } from '@utils'

// ** Store & Actions
import { useDispatch, useSelector } from 'react-redux'
import { handleLogout, getUserInfo } from '@store/actions/auth'

// ** Third Party Components
import { UncontrolledDropdown, DropdownMenu, DropdownToggle, DropdownItem } from 'reactstrap'
import { Settings, Power } from 'react-feather'

// ** Default Avatar Image
import defaultAvatar from '../../../../assets/images/avatars/lluismas.jpeg'
import Avatar from '@material-ui/core/Avatar'

//Translations
import { FormattedMessage, useIntl } from "react-intl"
import { IntlContext } from "../../../../utility/context/Internationalization"

const UserDropdown = () => {
  // ** Store Vars
  const dispatch = useDispatch()

  //Get values from store
  const name = useSelector(state => state.auth.userName)
  const userImg = useSelector(state => state.auth.userImage)

  //** ComponentDidMount
  useEffect(() => {
    dispatch(getUserInfo())
  }, [])


  // ** State
  const [userData] = useState(null)

  //** Vars
  const userAvatar = (userData && userData.avatar) || defaultAvatar
  //Translations
  const context = useContext(IntlContext)
  const intl = useIntl()
  return (
    <UncontrolledDropdown tag='li' className='dropdown-user nav-item'>
      <DropdownToggle href='/' tag='a' className='nav-link dropdown-user-link' onClick={e => e.preventDefault()}>
        <div className='user-nav d-sm-flex d-none'>
          <span className='user-name font-weight-bold mb-0'>{name}</span>
        </div>
        <Avatar alt={name} className="mr-50" style={{ width: "40px", height: "40px" }} src={userImg} />
      </DropdownToggle>
      <DropdownMenu right>
        <DropdownItem tag={Link} to='/settings' >
          <Settings size={14} className='mr-75' />
          <span className='align-middle'>
            <FormattedMessage id="settings" />
          </span>
        </DropdownItem>
        <DropdownItem tag={Link} to='/login' onClick={() => dispatch(handleLogout())}>
          <Power size={14} className='mr-75' />
          <span className='align-middle'>
            <FormattedMessage id="logout" />
          </span>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}

export default UserDropdown
